import { Table as DigdirTable, TableBody, TableCell, TableFoot, TableHead, TableHeaderCell, TableRow, } from "@digdir/designsystemet-react";
const Table = DigdirTable;
Table.displayName = "Table";
TableHeaderCell.displayName = "Table.HeaderCell";
TableRow.displayName = "Table.Row";
TableBody.displayName = "Table.Body";
TableCell.displayName = "Table.Cell";
TableHead.displayName = "Table.Head";
TableFoot.displayName = "Table.Foot";
export { Table, TableBody, TableCell, TableFoot, TableHead, TableHeaderCell, TableRow, };
//# sourceMappingURL=table.js.map